import React, {/*useState, useEffect*/} from 'react';
import './index.css';
import Home from './routes/Home';
import ReactGA from 'react-ga'
import About from './routes/About';
import Pay from './routes/Pay'
import News from './routes/News';
import Contact from './routes/Contact';
import Project from './routes/Project';
import { Route, Routes } from 'react-router-dom';
/*import PacmanLoader from "react-spinners/PacmanLoader";*/

const TRACKING_ID = "UA-277049772-2";
ReactGA.initialize(TRACKING_ID);


function App() {
 /* const [loading, setLoading] = useState(false)
  useEffect (() =>{

    setLoading(true)
    setTimeout(()=>{
      setLoading(false)
    }, 2000)

  },[])*/
  return (
    <>
    {
      /*loading?
      <PacmanLoader className='loadingg'
        color={'#FFCB94'}
        loading={loading}
        size={20}
      /> :*/
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/project" element={<Project />} />
      <Route path="/news" element={<News/>}/>
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pay" element={<Pay/>}/>
    </Routes>
}
  </>
  );
}

export default App;
